import { chatApiAxios } from "@/plugins";
import { HttpRequestMethodEnum } from "@/types/api";
import { IMarkMessageAsReadObject } from "@/types/chat";

export const markMessageAsReadBeAsync = async ({
  messageId,
  accessToken,
}: IMarkMessageAsReadObject) => {
  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };
  const res = await chatApiAxios("message/" + messageId + "/mark-as-read", {
    method: HttpRequestMethodEnum.PATCH,
    headers,
  });
  return res.data;
};
